import React from 'react';

const PtpNotification = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none">
      <circle cx="14" cy="14" r="14" fill="#FFFAE8" />
      <path
        fill="#C8A311"
        d="M17.7805 9.696h-2.4c.4267.3733.6933.8747.8 1.504h1.6v1.104h-1.552c-.0853.8533-.416 1.5413-.992 2.064-.5653.512-1.328.8053-2.288.88L16.2765 20h-2.032l-3.072-4.736h-1.12v-1.312h2.144c1.3973 0 2.192-.5493 2.384-1.648h-4.528V11.2h4.496c-.2027-1.0027-.9867-1.504-2.352-1.504h-2.144V8.608h7.728v1.088Z"
      />
    </svg>
  );
};

export default PtpNotification;
